import React, { useState } from "react";
import { loginState } from "../states.ts";
import { login, LoginResponse, authErrorMessage } from "../api/auth_api.ts";
import { Input } from "@/components/ui/input.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Link, useLocation } from "wouter";
import { AxiosError } from "axios";
import { Errors, FormError } from "@/pages/RegistrationPage.tsx";

const LoginPage: React.FC = () => {
	const [email, setEmail] = useState("");
	const [pass, setPass] = useState("");
	const [errors, setErrors] = useState<LoginResponse["errors"]>(undefined);
	const [formError, setFormError] = useState<string>();
	const [location, setLocation] = useLocation();
	const [loading, setLoading] = useState(false);

	const handleLogin = (e: React.BaseSyntheticEvent) => {
		e.preventDefault();
		setErrors({});
		setFormError(undefined);
		setLoading(true);
		login(email, pass)
			.then((response) => {
				if (response.ok && response.token) {
					loginState.token = response.token;
					setLocation("/");
				}
			})
			.catch((e: AxiosError<LoginResponse>) => {
				setErrors(e.response?.data.errors);
				setFormError(authErrorMessage(e));
			})
			.finally(() => setLoading(false));
	};

	return (
		<div className={"flex justify-center items-center h-screen"}>
			<form
				onSubmit={handleLogin}
				target={"#"}
				className={"flex flex-col gap-4 flex-1 w-full max-w-[300px] p-4"}
			>
				<h2 className={"text-xl font-bold"}>Login</h2>
				<FormError error={formError} />
				<Errors errors={errors} field={"login"} />
				<label>
					Email
					<Input
						type="text"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<Errors errors={errors} field={"email"} />
				</label>
				<label>
					<div className={"flex justify-between"}>
						<div>Password</div>
						<Link
							to={"/recover-password"}
							className={
								"text-xs py-2 text-secondary-foreground/50"
							}
						>
							Recover Password
						</Link>
					</div>
					<Input
						type="password"
						placeholder={"Password"}
						value={pass}
						onChange={(e) => setPass(e.target.value)}
					/>
					<Errors errors={errors} field={"password"} />
				</label>
				<div className={"flex justify-between items-center"}>
					<Button
						type={"submit"}
						onClick={handleLogin}
						className={"w-full sm:w-6/12"}
						disabled={loading}
					>
						Login
					</Button>
					<Link
						to={"/register"}
						className={"text-secondary-foreground/80"}
					>
						Register
					</Link>
				</div>
			</form>
		</div>
	);
};

export { LoginPage };
